var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: ', ';\n  padding: ', ';\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n  .pane {\n    flex-basis: 50%;\n    @media (max-width: 768px) {\n      flex-basis: auto;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  padding: ', ';\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n  .pane {\n    flex-basis: 50%;\n    @media (max-width: 768px) {\n      flex-basis: auto;\n    }\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import Pane from './Pane';
var Container = styled.div(_templateObject, function (props) {
  return props.direction || 'row';
}, function (props) {
  return props.padding || '0px';
});

var TwoPane = function TwoPane(props) {
  var debug = props.debug,
      minheight = props.minheight,
      left = props.left,
      right = props.right,
      paneClass = props.paneClass,
      panePadding = props.panePadding,
      vertical = props.vertical;
  var classNames = (paneClass || "") + ' pane';
  return React.createElement(Container, props, React.createElement(Pane, {
    padding: panePadding || "0px",
    className: classNames,
    debug: debug,
    minheight: minheight,
    vertical: vertical
  }, left), React.createElement(Pane, {
    padding: panePadding || "0px",
    className: classNames,
    debug: debug,
    minheight: minheight,
    vertical: vertical
  }, right));
};

export default TwoPane;